import { render, staticRenderFns } from "./ErrorConfirmDialog.vue?vue&type=template&id=0f60d244&"
import script from "./ErrorConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports